import './ForgotPassword.css';
import logo from '../../assets/images/logo.svg';
import { useNavigate, useLocation } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import { axiosInstance } from '../../config/axiosConfig';
import { FORGOT_PASSOWRD, FORGOT_PASSOWRD_CONFIMR } from '../../config/endpoint';
import loaderService from '../../service/loaderService';
import { showError, showSuccess } from '../../service/toastService';
import { useState } from 'react';
import { MdOutlineVisibility, MdOutlineVisibilityOff } from 'react-icons/md';

const ForgotPassword = () => {
  const navigate = useNavigate();
  const { state } = useLocation();
  const emailFromLocation = state?.email || '';
  const [otpSent, setOtpSent] = useState(false);
  const [isShowPassword, setIsShowPassword] = useState(false)
  const schema = yup.object().shape({
    email: yup.string().email('Invalid email format').required('Email is required'),
    ...(otpSent && {
      confirmationCode: yup
        .string()
        .required('OTP is required')
        .matches(/^\d{6}$/, 'OTP must be 6 digits'),
      newPassword: yup
        .string()
        .required('Password is required')
        .min(6, 'Password must be at least 6 characters'),
    }),
  });

  const {
    register,
    handleSubmit,
    formState: { errors, isSubmitting },
    getValues,
  } = useForm({
    resolver: yupResolver(schema),
    defaultValues: {
      email: emailFromLocation,
      confirmationCode: '',
      newPassword: '',
    },
  });

  const onSubmit = async (data) => {
    loaderService.show();
    try {
      if (!otpSent) {
        const res = await axiosInstance.post(FORGOT_PASSOWRD, { email: data.email });
        if (res?.data?.CodeDeliveryDetails) {
          setOtpSent(true);
        }
      } else {
        const res = await axiosInstance.post(FORGOT_PASSOWRD_CONFIMR, {
          email: data.email,
          confirmationCode: data.confirmationCode,
          newPassword: data.newPassword,
        });
        showSuccess('Password reset successful!');
        navigate('/login');
      }
    } catch (err) {
      showError(err?.response?.data?.message || 'Something went wrong');
    } finally {
      loaderService.hide();
    }
  };

  return (
    <div className="forgot">
      <div className="py-32">
        <img src={logo} alt="logo" />
      </div>
      <div className="forgot_form_container">
        <div className="forgot_form">
          <div className="heading">
            Forgot Password <b>brainyagent.ai</b>
          </div>
          <form
            className="w-100 gap-16 d-flex flex-column"
            autoComplete="off"
            onSubmit={handleSubmit(onSubmit)}
          >
            <div>
              <div className="input-container">
                <label htmlFor="email">Email Address</label>
                <input
                  id="email"
                  type="email"
                  className="input"
                  {...register('email')}
                  placeholder="Enter your email"
                  disabled={otpSent}
                />
              </div>
              {errors.email && (
                <p className="error-message">{errors.email.message}</p>
              )}
            </div>

            {otpSent && (
              <>
                <div>
                  <div className="input-container">
                    <label htmlFor="confirmationCode">Enter OTP</label>
                    <input
                      id="confirmationCode"
                      type="text"
                      className="input"
                      {...register('confirmationCode')}
                      placeholder="Enter the 6-digit OTP"
                    />
                  </div>
                  {errors.confirmationCode && (
                    <p className="error-message">{errors.confirmationCode.message}</p>
                  )}
                </div>

                <div>
                  <div className="input-container">
                    <label htmlFor="newPassword">New Password</label>
                    <input
                      id="newPassword"
                      type={isShowPassword ? 'text' : 'password'}
                      className="input"
                      {...register('newPassword')}
                      placeholder="Enter new password"
                    />
                    <div className='icon'>
                      {isShowPassword ?
                        <MdOutlineVisibilityOff size={22} color='#C3C6CF' onClick={() => setIsShowPassword(false)} /> :
                        <MdOutlineVisibility size={22} color='#C3C6CF' onClick={() => setIsShowPassword(true)} />
                      }
                    </div>
                  </div>
                  {errors.newPassword && (
                    <p className="error-message">{errors.newPassword.message}</p>
                  )}
                </div>
              </>
            )}

            <button type="submit" className="theme-sky-btn" disabled={isSubmitting}>
              {otpSent ? 'Reset Password' : 'Send OTP'}
            </button>

              <p className="color-white fw-light text-center">
                Remembered?{" "}
                <span
                  className="text-decoration-underline cursor-pointer"
                  onClick={() => navigate('/login')}
                >
                  Go to Login
                </span>
              </p>
          </form>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;
